// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.update-container {
  display: flex;
  gap: 40px;
  flex-wrap: wrap;
  justify-content: center;
}
.update-container .img-container {
  width: 150px;
  height: 150px;
}
.update-container .img-container img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  /* border-radius: 80px; */
}
.hide-show-btn {
  position: absolute;
  margin-top: -25px;
  margin-left: 320px;
}
.form-password-feild {
  position: relative;
}
.profile-details {
  width: 40%;
}
.profile-details .form-feild span {
  font-size: 12px;
  color: red;
}
`, "",{"version":3,"sources":["webpack://./src/Component/Dashboard/profile/profile.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;EACf,UAAU;AACZ","sourcesContent":[".update-container {\n  display: flex;\n  gap: 40px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n.update-container .img-container {\n  width: 150px;\n  height: 150px;\n}\n.update-container .img-container img {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  /* border-radius: 80px; */\n}\n.hide-show-btn {\n  position: absolute;\n  margin-top: -25px;\n  margin-left: 320px;\n}\n.form-password-feild {\n  position: relative;\n}\n.profile-details {\n  width: 40%;\n}\n.profile-details .form-feild span {\n  font-size: 12px;\n  color: red;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
